<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form" :gutter="20">
      <el-col :span="12" v-if="form.beforeStr && form.beforeStr.courseSubject">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">课程名称：{{form.beforeStr.courseSubject.name}}</div>
          <!-- <div class="item">福利类型：{{form.beforeStr.courseSubject.welfare_name}}</div>
          <div class="item">课程分类：{{form.beforeStr.courseSubject.class_name}}</div> -->
          <div class="item">封面图：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.courseSubject.cover_image" :preview-src-list="[form.beforeStr.courseSubject.cover_image]"></el-image></div>
          <div class="item" v-if="form.beforeStr.courseSubject.real_name">讲师：{{form.beforeStr.courseSubject.real_name}}</div>
          <div class="item">播放/浏览量：{{form.beforeStr.courseSubject.play_num}}</div>
          <div class="item">点赞量：{{form.beforeStr.courseSubject.like_num}}</div>
          <div class="item">收藏量：{{form.beforeStr.courseSubject.collect_num}}</div>
          <div class="item">转发量：{{form.beforeStr.courseSubject.forward_num}}</div>
          <div class="item">状态：{{form.beforeStr.courseSubject.state?'启用':'禁用'}}</div>
          <div class="title-box"><span class="txt1">课程配置</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="课程类型">{{form.beforeStr.courseSubject.type === 1?'图文':'视频'}}</el-descriptions-item>

          </el-descriptions>
          <template v-if="form.beforeStr.courseSubject.type === 2">
            <el-descriptions :column="1">
              <el-descriptions-item label="课程介绍"></el-descriptions-item>
            </el-descriptions>
            <div v-html="form.beforeStr.courseSubject.introduce"></div>
          </template>
          <template v-if="form.beforeStr.courseSubject.type === 1">
            <el-descriptions :column="1">
              <el-descriptions-item label="课程内容"></el-descriptions-item>
            </el-descriptions>
            <div v-html="form.beforeStr.courseSubject.content"></div>
          </template>
          <!-- <el-descriptions :column="1">
            <el-descriptions-item label="课程" v-if="form.beforeStr.courseSubject.type === 2"></el-descriptions-item>
          </el-descriptions>
          <template v-if="form.beforeStr.courseSubject.type === 2">
            <el-table :data="form.beforeStr.courseSubject.courseSubjectVideoList">
              <el-table-column label="章节节数" prop="chaptersNum" align="center" />
              <el-table-column label="章节名称" prop="name" align="center" />
              <el-table-column label="封面图" align="center">
                <template slot-scope="{row}">
                  <el-image style="width: 50px; height: 50px" v-if="row.beforeStr.courseSubject.coverImage" :src="row.beforeStr.courseSubject.coverImage" :preview-src-list="[row.beforeStr.coverImage]"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="视频课" prop="videoUrl" align="center" />
              <el-table-column label="添加时间" prop="createdTime" align="center" />
              <el-table-column label="状态" prop="name" align="center">
                <template slot-scope="{row}">
                  {{row.state?'启用':'禁用'}}
                </template>
              </el-table-column>
              <el-table-column label="修改时间" prop="operatedTime" align="center" />
              <el-table-column label="操作人" prop="operatedBy" align="center" />
            </el-table>
            <div class="title-box"><span class="txt1">课件</span></div>
            <el-table :data="form.beforeStr.courseSubject.courseSubjectWaresList">
              <el-table-column label="课件" align="center">
                <template slot-scope="{row}">
                  {{row.wareUrl}} <el-link type="primary" @click="handleDownload(row)">下载</el-link>
                </template>
              </el-table-column>
              <el-table-column label="添加时间" prop="createdTime" align="center" />
              <el-table-column label="状态" align="center">
                <template slot-scope="{row}">
                  {{row.state?'启用':'禁用'}}
                </template>
              </el-table-column>
              <el-table-column label="修改时间" prop="operatedTime" align="center" />
              <el-table-column label="操作人" prop="operatedBy" align="center" />
            </el-table>
            <div class="title-box"><span class="txt1">修复方案</span></div>
            <div v-for="(item,index) in form.beforeStr.courseSubject.courseSubjectRepairPlanList" :key="index">
              <div>方案{{index + 1}}</div>
              <el-descriptions :column="3">
                <el-descriptions-item label="修复方案名称">{{item.name}}</el-descriptions-item>
                <el-descriptions-item label="封面图"><el-image style="width: 50px; height: 50px" :src="item.coverImage" :preview-src-list="[item.coverImage]"></el-image></el-descriptions-item>
                <el-descriptions-item label="方案介绍">{{item.introduce}}</el-descriptions-item>
                <el-descriptions-item label="状态">{{item.state?'启用':'禁用'}}</el-descriptions-item>
                <el-descriptions-item label="修改时间">{{item.operatedTime}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{item.operatedBy}}</el-descriptions-item>
                <el-descriptions-item label="详情">
                  <div v-html="item.introduce"></div>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </template> -->
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr && form.afterStr.courseSubject">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">课程名称：{{form.afterStr.courseSubject.name}}</div>
          <!-- <div class="item">福利类型：{{form.afterStr.courseSubject.welfare_name}}</div>
          <div class="item">课程分类：{{form.afterStr.courseSubject.class_name}}</div> -->
          <div class="item">封面图：<el-image style="width: 50px; height: 50px" :src="form.afterStr.courseSubject.cover_image" :preview-src-list="[form.afterStr.courseSubject.cover_image]"></el-image></div>
          <div class="item" v-if="form.afterStr.courseSubject.real_name">讲师：{{form.afterStr.courseSubject.real_name}}</div>
          <div class="item">播放/浏览量：{{form.afterStr.courseSubject.play_num}}</div>
          <div class="item">点赞量：{{form.afterStr.courseSubject.like_num}}</div>
          <div class="item">收藏量：{{form.afterStr.courseSubject.collect_num}}</div>
          <div class="item">转发量：{{form.afterStr.courseSubject.forward_num}}</div>
          <div class="item">状态：{{form.afterStr.courseSubject.state?'启用':'禁用'}}</div>
          <div class="title-box"><span class="txt1">课程配置</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="课程类型">{{form.afterStr.courseSubject.type === 1?'图文':'视频'}}</el-descriptions-item>

          </el-descriptions>
          <template v-if="form.afterStr.courseSubject.type === 2">
            <el-descriptions :column="1">
              <el-descriptions-item label="课程介绍"></el-descriptions-item>
            </el-descriptions>
            <div v-html="form.afterStr.courseSubject.introduce"></div>
          </template>
          <template v-if="form.afterStr.courseSubject.type === 1">
            <el-descriptions :column="1">
              <el-descriptions-item label="课程内容"></el-descriptions-item>
            </el-descriptions>
            <div v-html="form.afterStr.courseSubject.content"></div>
          </template>
          <!-- <el-descriptions :column="1">
            <el-descriptions-item label="课程" v-if="form.afterStr.courseSubject.type === 2"></el-descriptions-item>
          </el-descriptions>
          <template v-if="form.afterStr.courseSubject.type === 2">
            <el-table :data="form.afterStr.courseSubject.courseSubjectVideoList">
              <el-table-column label="章节节数" prop="chaptersNum" align="center" />
              <el-table-column label="章节名称" prop="name" align="center" />
              <el-table-column label="封面图" align="center">
                <template slot-scope="{row}">
                  <el-image style="width: 50px; height: 50px" v-if="row.afterStr.coverImage" :src="row.afterStr.coverImage" :preview-src-list="[row.afterStr.coverImage]"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="视频课" prop="videoUrl" align="center" />
              <el-table-column label="添加时间" prop="createdTime" align="center" />
              <el-table-column label="状态" prop="name" align="center">
                <template slot-scope="{row}">
                  {{row.state?'启用':'禁用'}}
                </template>
              </el-table-column>
              <el-table-column label="修改时间" prop="operatedTime" align="center" />
              <el-table-column label="操作人" prop="operatedBy" align="center" />
            </el-table>
            <div class="title-box"><span class="txt1">课件</span></div>
            <el-table :data="form.afterStr.courseSubject.courseSubjectWaresList">
              <el-table-column label="课件" align="center">
                <template slot-scope="{row}">
                  {{row.wareUrl}} <el-link type="primary" @click="handleDownload(row)">下载</el-link>
                </template>
              </el-table-column>
              <el-table-column label="添加时间" prop="createdTime" align="center" />
              <el-table-column label="状态" align="center">
                <template slot-scope="{row}">
                  {{row.state?'启用':'禁用'}}
                </template>
              </el-table-column>
              <el-table-column label="修改时间" prop="operatedTime" align="center" />
              <el-table-column label="操作人" prop="operatedBy" align="center" />
            </el-table>
            <div class="title-box"><span class="txt1">修复方案</span></div>
            <div v-for="(item,index) in form.afterStr.courseSubject.courseSubjectRepairPlanList" :key="index">
              <div>方案{{index + 1}}</div>
              <el-descriptions :column="3">
                <el-descriptions-item label="修复方案名称">{{item.name}}</el-descriptions-item>
                <el-descriptions-item label="封面图"><el-image style="width: 50px; height: 50px" :src="item.coverImage" :preview-src-list="[item.coverImage]"></el-image></el-descriptions-item>
                <el-descriptions-item label="方案介绍">{{item.introduce}}</el-descriptions-item>
                <el-descriptions-item label="状态">{{item.state?'启用':'禁用'}}</el-descriptions-item>
                <el-descriptions-item label="修改时间">{{item.operatedTime}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{item.operatedBy}}</el-descriptions-item>
                <el-descriptions-item label="详情">
                  <div v-html="item.introduce"></div>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </template> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
::v-deep .el-col-12 {
  padding-right: 30px;
}
</style>
